module.exports = Object.freeze({
    MatchingLevels: {
        FULL_MATCH: 1,
        PARTIAL_MATCH: 2,
        PARTIAL_MATCH_SUGGESTIONS: 3,
    }
});